import React, { useState } from "react";
import "./ContactUsMain.css";

const ContactUsMain: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState<{ type: "success" | "error"; msg: string } | null>(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const res = await fetch("http://localhost:5001/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "Something went wrong");

      setStatus({ type: "success", msg: "Message sent successfully!" });
      setFormData({ name: "", email: "", message: "" });
    } catch (err: any) {
      setStatus({ type: "error", msg: err.message || "Failed to send message" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Left Section */}
        <div className="contact-info">
          <p className="contact-subtitle">CONTACT US</p>
          <h2 className="contact-title">
            Get In <span>Touch</span>
          </h2>
          <p className="contact-description">
            Contact us today to discuss your temporary and permanent staffing
            requirements and discover how BreezNest Ltd can support your business
            with reliable, qualified, and flexible workforce solutions. Our team
            is ready to assist you and provide the exceptional service you
            deserve.
          </p>

          <div className="contact-details">
            <p>
              📞 <a href="tel:+447532848379">+44 7360 244109</a>
            </p>
            <p>
              🏠 Office address: 1st Floor 218-220 Whitechapel Road London E1 1BJ
            </p>
           
          </div>
        </div>

        {/* Right Section */}
        <div className="contact-form">
          <form onSubmit={handleSubmit}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label>Message</label>
            <textarea
              name="message"
              placeholder="Message"
              rows={3}
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send"}
            </button>

            {status && (
              <p className={status.type === "success" ? "success-msg" : "error-msg"}>
                {status.msg}
              </p>
            )}
          </form>
        </div>
      </div>

      {/* Map Section */}
      <div className="contact-map">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d79467.55084326147!2d-0.12204187101106119!3d51.50659338624518!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604b900d26973%3A0x4291f3172409ea92!2sLondon%20Eye!5e0!3m2!1sen!2sus!4v1758832692395!5m2!1sen!2sus"
          style={{ border: 0, width: "100%", height: "800px" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactUsMain;
